import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
import { Section } from './Section';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <Section tone="tint" eyebrow="Testimonios" title="Lo que dicen quienes lo utilizan" width="narrow" data-id="element-253" data-mp="3fze2zvj28zum">
      <ul className="mx-auto max-w-4xl divide-y divide-blue-200/70" data-id="element-254" data-mp="3azje1xiuikc7">
        {testimonials.map(item => <li key={item.author} className="grid gap-4 py-7 first:pt-0 last:pb-0 md:grid-cols-[minmax(0,15rem)_1fr] md:gap-10" data-id="element-255" data-mp="36zqz932uzhye">
            <div className="flex items-start gap-3" data-id="element-256" data-mp="2x09vwsb2xg5l">
              <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-blue-600 text-xs font-bold text-white" data-id="element-257" data-mp="2x11ri34ofdvv">
                {item.initials}
              </span>
              <span data-id="element-258" data-mp="v8wvogk23wfv">
                <span className="flex gap-0.5" aria-label="5 estrellas de 5" data-id="element-259" data-mp="v72ixpixvamv">
                  {Array.from({
                length: 5
              }).map((_, index) => <StarIcon key={index} className="h-4 w-4 fill-blue-500 text-blue-500" aria-hidden="true" data-id="element-260" data-mp="h5oox8u9426d" data-mpi={index} />)}
                </span>
                <span className="mt-1.5 block font-extrabold tracking-tight text-slate-900" data-id="element-261" data-mp="79li3pogffd3">
                  {item.author}
                </span>
                <span className="block text-sm text-blue-900/70" data-id="element-262" data-mp="zvwgqusi3679">{item.role}</span>
                {item.city && <span className="inline-flex items-center gap-1 text-sm text-blue-900/60" data-id="element-263" data-mp="14uhgkt3ubnv6">
                    <MapPinIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-264" data-mp="q5la30hfmiwo" />
                    {item.city}
                  </span>}
              </span>
            </div>
            <blockquote className="text-lg italic leading-relaxed text-slate-900 md:text-xl" data-id="element-265" data-mp="1iusak50g5ikk">
              “{item.quote}”
            </blockquote>
          </li>)}
      </ul>
    </Section>;
}